import Remark from "./KrRemark.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrRemark = install(Remark); // 生成带有 install 方法的组件

export default KrRemark;
